import React, { useState } from "react";
import "../../landing.css";
import "./style.css";
import localeText from "../../../../locale";
import { locale } from "../../../../utilities/locale/locale";

const VIDEO_ID = "NKoGFRVmbCk";
const VIDEO_LANG = "it";
// Não existe thumbnail maxres para este vídeo; a sd (4:3 com letterbox) é recortada para 16:9 via CSS
const THUMBNAIL_URL = `https://i.ytimg.com/vi/${VIDEO_ID}/sddefault.jpg`;

const buildEmbedUrl = () => {
  const params = new URLSearchParams({
    autoplay: "1",
    rel: "0",
    modestbranding: "1",
    playsinline: "1",
    hl: locale,
  });
  // Fora do italiano, já abre com legendas no idioma do visitante (tradução automática do YouTube)
  if (locale !== VIDEO_LANG) {
    params.set("cc_load_policy", "1");
    params.set("cc_lang_pref", locale);
  }
  return `https://www.youtube-nocookie.com/embed/${VIDEO_ID}?${params.toString()}`;
};

// O iframe do YouTube só é carregado quando o visitante clica em play (facade),
// para não pesar no carregamento inicial da landing.
const LandingVideoSection = () => {
  const [playing, setPlaying] = useState(false);
  const title = localeText("lp2VideoTitle");

  return (
    <section id="video" className="landing-video-section full-width py-8">
      <div className="grid align-items-center">
        <div className="col-12 lg:col-5 lg:pr-6">
          <div className="eyebrow-text" style={{ color: "var(--extra-mint)" }}>
            {localeText("lp2VideoEyebrow")}
          </div>
          <h2 className="font-bold text-4xl md:text-5xl line-height-2 title mt-2 mb-0 text-white">
            {title}
          </h2>
          <p className="text-lg mt-3 mb-0 line-height-3 landing-video-description">
            {localeText("lp2VideoDescription")}
          </p>
          {locale !== VIDEO_LANG && (
            <p className="landing-video-language text-sm mt-4 mb-0 flex align-items-start gap-2">
              <i className="pi pi-globe mt-1" aria-hidden="true" />
              <span>{localeText("lp2VideoLanguageNote")}</span>
            </p>
          )}
        </div>

        <div className="col-12 lg:col-7 mt-4 lg:mt-0">
          <div className="landing-video-frame">
            {playing ? (
              <iframe
                src={buildEmbedUrl()}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            ) : (
              <button
                type="button"
                className="landing-video-facade"
                onClick={() => setPlaying(true)}
                aria-label={localeText("lp2VideoPlay")}
              >
                <img src={THUMBNAIL_URL} alt="" loading="lazy" decoding="async" />
                <span className="landing-video-play" aria-hidden="true">
                  <i className="pi pi-play" />
                </span>
                <span className="landing-video-cta">{localeText("lp2VideoPlay")}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingVideoSection;
